import React from 'react'

const StaticHeaderSpacer = () => {
    return <div className="static-sp" />
}

export default StaticHeaderSpacer
